import { render, staticRenderFns } from "./PresidentialElectionsFirstRound.vue?vue&type=template&id=40474484&"
import script from "./PresidentialElectionsFirstRound.vue?vue&type=script&lang=js&"
export * from "./PresidentialElectionsFirstRound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\larepublica\\lr-statics\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40474484')) {
      api.createRecord('40474484', component.options)
    } else {
      api.reload('40474484', component.options)
    }
    module.hot.accept("./PresidentialElectionsFirstRound.vue?vue&type=template&id=40474484&", function () {
      api.rerender('40474484', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lr/js/vue/components/presidential-elections-first-round/PresidentialElectionsFirstRound.vue"
export default component.exports